import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

const user = {
  state() {
    checkAndAddAccountInURL();

    return {
      token: localStorage.getItem("token"),
      account: getAccountParamOrLocal(),
      is_superuser: false,
      is_staff: false,
      id: null,
      // theme: localStorage.getItem("theme"),
      theme: "LIGTH",
      created_at: "",
      complet_onboarding: "",
      email: "",
      name: "",
    };
  },
  mutations: {
    clean(state) {
      state.token = null;
      state.account = null;
      localStorage.removeItem("token");
      localStorage.removeItem("account");
      localStorage.removeItem("account-last-updated");
      localStorage.removeItem("resources");

      // delete cookies django
      let delete_cookie = function(name) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      };
      // fix to auth django admin worker
      delete_cookie("csrftoken");
    },
    updateUser(state, data) {
      if (data.token) {
        state.token = data.token;
        localStorage.setItem("token", data.token);
      }
      if (data.account) {
        state.account = data.account;
        localStorage.setItem("account", data.account);
        checkAndAddAccountInURL(data.account);
      }
      if (data.is_superuser !== undefined) {
        state.is_superuser = data.is_superuser;
        // set bluerMoney interface
        if (!data.is_superuser) {
          localStorage.setItem("blurMoney", true);
        }
      }
      if (data.theme) {
        localStorage.setItem("theme", data.theme);
        state.theme = data.theme;
      }
      if (data.is_staff) {
        state.is_staff = data.is_staff;
      }
      if (data.id) {
        state.id = data.id;
      }
      if (data.email) {
        state.email = data.email;
      }
      if (data.created_at) {
        state.created_at = data.created_at;
      }

      if (data.name) {
        state.name = data.name;
      }
      if (data.complet_onboarding != undefined) {
        state.complet_onboarding = data.complet_onboarding;
      }
    },
  },
  actions: {
    logout({ commit }) {
      commit("clean");
    },
    auth({ commit }, val) {
      commit("updateUser", val);
    },
  },
};

export const getAccountParamOrLocal = () => {
  let account = localStorage.getItem("account");

  let url = window.location.toString();
  if (url && url.includes("#")) {
    let auxParam = url.split("#")[1];

    // fail split
    if (!auxParam) {
      return account;
    }

    auxParam = auxParam.split("acc=");

    // fail split
    if (auxParam && auxParam.length < 2) {
      return account;
    }

    account = auxParam[1];
  }

  return account;
};

export const checkAndAddAccountInURL = (accountId) => {
  let url = window.location.toString();
  let localAcc = localStorage.getItem("account");

  // set default value in URL
  if (url && !url.includes("#")) {
    let newAcc = localAcc;
    if (accountId) {
      newAcc = accountId;
    }

    if (newAcc) {
      window.location = window.location + `#acc=${newAcc}`;
    }
  } else if (accountId && url && url.includes("#")) {
    // Update Acc Id Param

    let auxAcc = getAccountParamOrLocal();
    // update acc Id in Url
    if (auxAcc !== accountId) {
      let auxUrl = url.split("#")[0];

      window.location.href = auxUrl + `#acc=${accountId}`;
    }
  }
};

let resources = [];
try {
  resources = JSON.parse(localStorage.getItem("resources") || "[]");
} catch (e) {
  console.log("e", e);
}

const account = {
  state() {
    return {
      id: localStorage.getItem("account"),
      name: null,
      tax_rate: null,
      email: null,
      phone: null,
      plan: null,
      plan_id: null,
      plan_description: null,
      status: null,
      account_type: null,
      flag_payment: false,
      flag_sale_no_data: false,
      data_updated: null,
      payment_platform: "STRIPE",
      currency_preference: null,
      plan_limits: {},
      used_limits: {},
      flag_tag_no_data: false,
      account_manager_name: null,
      account_manager_name_id: null,
      afiliate: null,
      afiliate_code: null,
      afiliate_kiwify_code: null,
      choice_plan: null,
      tax_type: null,
      timezone: null,
      resources: resources,
    };
  },
  mutations: {
    updateAccount(state, data) {
      checkAndAddAccountInURL(data.id);

      state.id = data.id;
      state.name = data.name;
      state.tax_rate = data.tax_rate;
      state.email = data.email;
      state.phone = data.phone;
      state.plan = data.plan;
      state.plan_limit_sales_approved_month = data.plan_limit_sales_approved_month;
      state.plan_id = data.plan_id;
      state.plan_description = data.plan_description;
      state.status = data.status;
      state.resources = data.resources;
      localStorage.setItem("resources", JSON.stringify(data.resources));
      state.account_type = data.account_type;
      state.currency_preference = data.currency_preference;
      state.flag_payment = data.flag_payment;
      state.payment_platform = data.payment_platform;
      state.data_updated = data.last_data_updated;
      state.afiliate = data.afiliate;
      state.afiliate_code = data.afiliate_code;
      state.afiliate_kiwify_code = data.afiliate_kiwify_code;
      state.choice_plan = data.choice_plan;
      state.tax_type = data.tax_type;
      state.timezone = data.timezone;

      state.flag_tag_no_data = data.flag_tag_no_data;
      state.flag_sale_no_data = data.flag_sale_no_data;


      state.account_manager_name = data.account_manager_name;
      state.account_manager_id = data.account_manager_id;
        
      state.plan_limits = data.plan_limits;
      state.used_limits = data.used_limits;

    },
  },
  actions: {
    setAccount({ commit }, val) {
      commit("updateAccount", val);
    },
  },
};

const cancelRequests = {
  state() {
    return {
      cancelTokens: [],
    };
  },
  getters: {
    cancelTokens(state) {
      return state.cancelTokens;
    },
  },
  mutations: {
    ADD_CANCEL_TOKEN(state, token) {
      state.cancelTokens.push(token);
    },
    CLEAR_CANCEL_TOKENS(state) {
      state.cancelTokens = [];
    },
  },
  actions: {
    CANCEL_PENDING_REQUESTS(context) {
      // Cancel all request where a token exists
      context.state.cancelTokens.forEach((request) => {
        if (request.cancel) {
          request.cancel("request-canceled");
        }
      });
      // Reset the cancelTokens store
      context.commit("CLEAR_CANCEL_TOKENS");
    },
  },
};

const breadcrumb = {
  state() {
    return {
      bclist: [],
    };
  },
  mutations: {
    updateBreadcrumb(state, data) {
      if (data.breadcrumb) state.bclist = data.breadcrumb;
      if (data.idx && data.name && state.bclist[data.idx])
        state.bclist[data.idx].name = data.name;
      if (data.idx && data.params && state.bclist[data.idx])
        state.bclist[data.idx].params = data.params;
    },
  },
  actions: {
    setBreadcrumb({ commit }, val) {
      commit("updateBreadcrumb", val);
    },
  },
};

export default new Vuex.Store({
  modules: {
    user,
    account,
    cancelRequests,
    breadcrumb,
  },
});
